/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function DotsThreeVertical(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={128} cy={64} r={10} />
      <Circle cx={128} cy={128} r={10} />
      <Circle cx={128} cy={192} r={10} />
    </Svg>
  );
}

export default DotsThreeVertical;
